<template>
  <div v-loading="loading">
    <el-form
      ref="formRef"
      :model="formData"
      label-width="85px"
      label-position="left"
      size="mini"
      :rules="rules"
      :disabled="disabled"
    >
      <div class="d-flex">
        <div class="image_div">
          <el-image
            :src="defaultImageUrl"
            :preview-src-list="[defaultImageUrl]"
            style="width: 187px; height: 125px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width: 135px; height: 135px"
              />
            </div>
          </el-image>
          <br />
          <el-button
            type="primary"
            style="
                width: 187px;
                height: 32px;
                line-height: 2px;
                margin-top: 5px;
              "
            @click="visible = true"
            :disabled="disabled"
            >{{ $l('btn_choose_image') || '选择图片' }}</el-button
          >
        </div>
        <div style="width:683px">
          <div class="el-form-row">
            <el-form-item
              :label="$l('from_label_sample_style_no') || '样品款号'"
            >
              <el-input v-model="formData.sampleStyleNo" readonly />
            </el-form-item>
            <el-form-item :label="$l('table_label_sampleSetStatus') || '状态'">
              <el-tag
                class="mt-2"
                size="mini"
                :type="formData.sampleStatus === 'S' ? 'warning' : 'primary'"
                >{{ formData.sampleStatusName || '新增' }}</el-tag
              >
            </el-form-item>
          </div>
          <div class="el-form-row">
            <el-form-item :label="$l('from_label_modify') || '更新时间'">
              <el-input v-model="modify" readonly />
            </el-form-item>
          </div>
          <div class="el-form-row">
            <el-form-item :label="$l('form_label_sampleName') || '中文名称'">
              <el-input v-model="formData.sampleName" readonly />
            </el-form-item>
          </div>
          <div class="el-form-row">
            <el-form-item :label="$l('form_label_sampleNameEn') || '英文名称'">
              <el-input v-model="formData.sampleNameEn" readonly />
            </el-form-item>
          </div>
          <div class="el-form-row">
            <el-form-item
              :label="$l('form_label_displayCategory') || '样品分类'"
              prop="categoryCode"
            >
              <category-cascader
                :masterCategoryCode.sync="formData.masterCategoryCode"
                :detailCategoryCode.sync="formData.categoryCode"
                :params="categoryParams"
                clearable
                size="mini"
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <el-form
      ref="form"
      :model="formData"
      label-width="120px"
      label-position="top"
      size="mini"
      :rules="rules"
      :disabled="disabled"
      @submit.native.prevent
    >
      <el-row :gutter="10" class="mt-2">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_in_set_en_name') || '套内产品英文名称'"
            prop="inSetNameEn"
          >
            <el-input
              v-model="formData.inSetNameEn"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              maxlength="200"
              :readonly="disabled"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_in_set_qty') || '套内数量'"
            prop="inSetQty"
          >
            <el-input-number
              v-model="formData.inSetQty"
              v-el-inputnumber-default0
              :controls="false"
              style="width: 100%"
              :precision="0"
              :min="1"
              :max="10"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('table_label_sampleWeight') || '产品重量'">
            <el-input-number
              v-model="formData.sampleWeight"
              placeholder="weight"
              clearable
              style="width:100%"
              :controls="false"
              :precision="2"
              :min="0"
              controls-position="right"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('table_label_sampleWeightUnit') || '产品重量单位'"
          >
            <dict-select
              :placeholder="
                $l('pe_select_sampleWeightUnit') || '请选择产品重量单位'
              "
              size="mini"
              clearable
              filterable
              v-model="formData.sampleWeightUnit"
              :body="sampleWeightUnitTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_moq') || '起订量'">
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.moq"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              :controls="false"
              :precision="0"
              :min="0"
              controls-position="right"
              style="width:100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_moqUnit') || '起订量单位'">
            <dict-select
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              v-model="formData.moqUnit"
              url="/master/common/dict/biz"
              :body="{ dictType: 'moqUnit' }"
              style="width: 100%"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_spec_length') || '长'"
            prop="specLength"
          >
            <el-input-number
              v-model="formData.specLength"
              v-el-inputnumber-default0
              :controls="false"
              style="width: 100%"
              :min="0"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_spec_width') || '宽'"
            prop="specWidth"
          >
            <el-input-number
              v-model="formData.specWidth"
              v-el-inputnumber-default0
              :controls="false"
              :min="0"
              style="width: 100%"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_spec_height') || '高'"
            prop="specHeight"
          >
            <el-input-number
              v-model="formData.specHeight"
              :controls="false"
              style="width: 100%"
              :min="0"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sampleSizeUnit') || '尺寸单位'"
            prop="sampleSizeUnit"
          >
            <dict-select
              :placeholder="$l('INDEX.tips_select_data') || '请选择'"
              size="mini"
              clearable
              filterable
              v-model="formData.sampleSizeUnit"
              :body="sampleSpecTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_fringe_size') || '流苏尺寸'">
            <el-input
              v-model="formData.fringeSize"
              :placeholder="$l('form_label_pe_fringe_size') || '请输入流苏尺寸'"
              type="text"
              maxlength="50"
              show-word-limit
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_costMainType') || '成本类型'"
            prop="costMainType"
          >
            <dict-select
              v-model="formData.costMainType"
              url="/sys/common/dict/system"
              :body="{ dictType: 'costMainType' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_costPrice') || '成本价格'">
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.costPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width:100%"
              clearable
              :controls="false"
              :precision="2"
              :min="0"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_costCurrency') || '成本币种'"
            prop="costCurrency"
          >
            <dict-select
              v-model="formData.costCurrency"
              url="/sys/common/dict/system"
              :body="{ dictType: 'currency' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              v-model="formData.quotedMethod"
              url="/sys/common/dict/system"
              :body="{ dictType: 'quotedMethod' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedPrice') || '建议报价'"
            prop="quotedPrice"
          >
            <el-input-number
              v-el-inputnumber-default0
              v-model="formData.quotedPrice"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width:100%"
              clearable
              :controls="false"
              :precision="2"
              :min="0"
              controls-position="right"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_quotedCurrency') || '报价币种'"
            prop="quotedCurrency"
          >
            <dict-select
              v-model="formData.quotedCurrency"
              url="/sys/common/dict/system"
              :body="{ dictType: 'currency' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              disabled
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('table_label_salesPrice') || '零售价'">
            <el-input-number
              v-model="formData.salesPrice"
              :placeholder="$l('pe_input_salesPrice') || '请输入零售价'"
              clearable
              :min="0"
              :step="0.01"
              :precision="2"
              controls-position="right"
              style="width:100%"
              v-el-inputnumber-default0
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('table_label_salesCurrency') || '零售价货币'"
          >
            <dict-select
              v-model="formData.salesCurrency"
              :placeholder="$l('pe_select_salesCurrency') || '请选择零售价货币'"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_packageSize') || '包装尺寸'">
            <el-input
              v-model="formData.packageSize"
              :placeholder="$l('pe_input_packageSize') || '请输入包装尺寸'"
              clearable
              show-word-limit
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('table_label_packageMethod') || '包装方式'">
            <dict-select
              v-model="formData.packageMethod"
              :placeholder="$l('pe_select_packageMethod') || '请选择包装方式'"
              url="/master/common/dict/biz"
              :body="packageMethodParams"
              clearable
              filterable
              multiple
              @loaded="(items) => (packageMethodItems = items)"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_scm') || '成品工厂'"
            prop="scmCode"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scm"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_scmProductNo') || '工厂产品编号'"
          >
            <el-input
              v-model="formData.scmProductNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
              maxlength="50"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('INDEX.label_customer') || '客户'">
            <dict-select
              clearable
              v-model="formData.custCode"
              filterable
              url="/master/common/dict/customerSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_a_customer') || '请选择客户'
              "
              style="width:100%"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('INDEX.form_label_brand') || '品牌'">
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_brand') || '请选择品牌'
              "
              style="width:100%"
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_customerProductNo') || '客人产品编号'"
          >
            <el-input
              v-model="formData.customerProductNo"
              :placeholder="
                $l('pe_select_customerProductNo') || '请输入客人产品编号'
              "
              maxlength="50"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('INDEX.form_label_poNo') || 'poNo'">
            <el-input v-model="formData.poNo" maxlength="50" clearable>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_dateOfSignature') || '签样日期'"
          >
            <el-date-picker
              v-model="formData.dateOfSignature"
              type="date"
              value-format="yyyy/MM/dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.form_label_custSampleName') || '客户样品名称'"
          >
            <el-input
              v-model="formData.custSampleName"
              maxlength="100"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('table_label_packageSize') || '包装尺寸'">
            <el-input
              v-model="formData.packageSize"
              :placeholder="$l('pe_input_packageSize') || '请输入包装尺寸'"
              clearable
              maxlength="200"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('table_label_packageMethod') || '包装方式'">
            <dict-select
              v-model="formData.packageMethod"
              url="/master/common/dict/biz"
              :body="packageMethodParams"
              :placeholder="$l('pe_select_packageMethod') || '请选择包装方式'"
              style="width: 100%"
              size="mini"
              clearable
              filterable
              multiple
              @loaded="(items) => (packageMethodItems = items)"
            />
          </el-form-item> </el-col
      ></el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('form_label_setTagMemo') || '吊牌标签备注'">
            <el-input
              v-model="formData.tagMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="2"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('form_label_sampleSetMemo') || '备注说明'">
            <el-input
              v-model="formData.sampleMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              :rows="2"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <DynamicForm
          v-model="dynamicFormData"
          :items.sync="listTemolate"
          :disabled="disabled"
          :gutter="10"
          ref="dynamicForm"
        />
      </el-row>

      <el-row>
        <el-tabs
          v-if="sampleCode"
          v-model="activeMaterialTab"
          type="border-card"
          style="width: 100%"
        >
          <el-tab-pane
            :label="$l('form_label_fabric_composition') || '面料构成'"
            name="fabric"
            lazy
          >
            <SampleFabricMaterial
              :sampleCode="sampleCode"
              :disabled="disabled"
              :productLine="formData.productLine || 'ABSHome'"
              :categoryCode="formData.masterCategoryCode"
              :proofingCode="''"
              :height="350"
              :buttonFlag="true"
            />
          </el-tab-pane>
          <el-tab-pane
            :label="$l('form_label_accessories_composition') || '辅料构成'"
            name="accessory"
            lazy
          >
            <SampleAccessoryMaterial
              :sampleCode="sampleCode"
              :disabled="disabled"
              :productLine="formData.productLine || 'ABSHome'"
              :categoryCode="formData.masterCategoryCode"
              :proofingCode="''"
              :height="350"
              :buttonFlag="true"
            />
          </el-tab-pane>
        </el-tabs>
      </el-row>
    </el-form>

    <SampleImage
      v-if="visible"
      :title="$l('btn_choose_image') || '选择图片'"
      :visible.sync="visible"
      :sampleSetCode="sampleSetCode"
      @setImage="setImage"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import SampleFabricMaterial from '@/views/backstage/sample/sampleInformation/detail/components/sample-fabric-material'
import SampleAccessoryMaterial from '@/views/backstage/sample/sampleInformation/detail/components/sample-accessory-material'
import DynamicForm from '@/components/dynamic-form'
import SampleImage from '../sample-image'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: {
    DynamicForm,
    SampleFabricMaterial,
    SampleAccessoryMaterial,
    SampleImage,
  },
  props: {
    disabled: { type: Boolean, default: false },
    productLine: { type: String, default: '' },
    sampleCode: { type: String, default: '' },
    sampleSetCode: { type: String, default: '' },
    baseInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        productLine: 'ABSHome',
        inSetQty: 1,
        brandCode: '',
        custCode: '',
      },
      loading: false,
      visible: false,
      activeMaterialTab: 'fabric',
      modify: '',
      sampleSpecTypeParams: { dictType: 'sampleSizeUnit' },
      sampleWeightUnitTypeParams: { dictType: 'sampleWeightUnit' },
      // currencyUnitParams: { dictType: 'currencyUnit' },
      packageMethodParams: { dictType: 'packageMethod' },
      dynamicFormData: {},
      listTemolate: [],
      // packageMethodItems: [],
    }
  },
  watch: {
    'formData.masterCategoryCode'(newVal, oldVal) {
      if (this.listTemolate?.length && !oldVal && newVal) return
      if (!newVal) return (this.listTemolate = [])
      this.$api
        .masSampleInputTemplateSelectApi({ sampleCategoryCode: newVal })
        .then((res) => {
          this.listTemolate = res.body?.data || []
        })
    },
    baseInfo: {
      handler(data) {
        const {
          costCurrency,
          quotedMethod,
          quotedCurrency,
          brandCode,
          custCode,
        } = data
        this.formData.costCurrency = costCurrency
        this.formData.quotedMethod = quotedMethod
        this.formData.quotedCurrency = quotedCurrency
        this.formData.brandCode = brandCode
        this.formData.custCode = custCode
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
    categoryParams() {
      return { parentCode: this.formData.productLine, isEcom: 'N' }
    },

    rules() {
      return {
        inSetNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        specLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('长必须大于0'))
              } else {
                callback()
              }
            },
          },
        ],
        specWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('宽必须大于0'))
              } else {
                callback()
              }
            },
          },
        ],
        inSetQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        sampleSizeUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        costMainType: [
          {
            required: true,
            message:
              this.$l('table_label_pe_select_costMainType') || '请选择成本类型',
            trigger: ' change',
          },
        ],
        costCurrency: [
          {
            required: true,
            message: this.$l('pe_select_costCurrency') || '请选择成本价格币种',
            trigger: 'blur',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('table_label_pe_select_quotedMethod') || '请选择报价方式',
            trigger: ' change',
          },
        ],
      }
    },
    packageMethodMaps() {
      if (!this.packageMethodItems?.length) return {}

      return Object.fromEntries(
        this.packageMethodItems.map((item) => [item.value, item])
      )
    },
    packageMethodName() {
      const packageMethod = this.formData?.packageMethod || []
      return packageMethod
        .map((item) => this.packageMethodMaps[item]?.label)
        .filter(Boolean)
        .join('、')
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getData()
      this.loading = false
    },
    async getData() {
      if (!this.sampleCode) return
      const res = await this.$api
        .sampleInfoDetailApi({
          sampleCode: this.sampleCode,
        })
        .catch(() => null)
      const data = res?.body || {}
      this.formData = { ...data }
      const { modifyByName, modifyDate, listTemolate } = data

      if (modifyByName) {
        this.modify = modifyByName + '  at  ' + modifyDate
      }
      this.listTemolate = listTemolate || []
      setTimeout(() => {
        this.$refs.form.clearValidate()
      }, 0)
    },
    setImage({ sampleSetImgCode, thumbImageUrl }) {
      this.formData = {
        ...this.formData,
        defaultImageUrl: thumbImageUrl,
        sampleSetImgCode: sampleSetImgCode,
      }
      this.visible = false
    },

    async confirm() {
      const result = await validate.formValidate([
        this.$refs.form,
        this.$refs.formRef,
        this.$refs.dynamicForm,
      ])
      if (!result) return
      this.loadingOpen()
      this.formData.metadata = this.listTemolate
      const params = {
        ...this.formData,
        sampleSetCode: this.sampleSetCode,
        categoryCodeName: this.sampleSetCode,
      }
      const res = await this.$api
        .sampleInfoSubProductSaveApi({
          ...params,
          packageMethodName: this.packageMethodName,
        })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.$emit('update:sampleCode', body || '')
      setTimeout(() => {
        this.getData()
        this.$emit('reload')
      }, 0)
    },
  },
}
</script>
<style lang="scss" scoped>
.image_div {
  border: 1px solid #ebeef5;
  border-right: none;
  padding: 4px 7px 0px 5px;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  line-height: 25px;
}
.label {
  font-weight: 600;
  color: #101010;
}

::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .border-bottom-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-bottom: none !important;
    }
  }

  .el-form .el-form-row {
    display: flex;
    border: 1px solid #ebeef5;
    border-left: none;
    .el-form-item {
      margin: 0 !important;
      position: relative;
      width: 100%;

      .el-form-item__label {
        color: #909399;
        background: #fafafa;
        box-sizing: border-box;
        text-align: left;
        font-weight: 400;
        line-height: 1.5;
        padding: 8px 10px;
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
        font-size: 12px !important;
        position: absolute;
        bottom: 0;
        top: 0;
      }

      .el-form-item__content {
        padding: 0 5px;
        box-sizing: border-box;
        text-align: left;
        font-weight: 400;
        line-height: 1.5;
        color: #606266;
        font-size: 12px !important;
        > div {
          margin: 3.2px 0;
        }
        > .el-input {
          input[readonly] {
            border: none;
            background-color: #fff;
            color: #606266;
            cursor: auto;
          }
        }
        .el-input-number .el-input__inner {
          text-align: left;
        }
        .no-error {
          .el-input__inner {
            border-color: #dcdfe6 !important;
          }
        }
      }
    }
  }

  .el-form .el-form-row:not(:first-child) {
    border-top: none;
  }
}
</style>
